import * as React from 'react';
import { AuthLayout } from './AuthLayout';
import MySetPasswordForm from './MySetPasswordForm';

/**
 * A component that renders a page for resetting the current user password through Supabase.
 * @param props
 * @param props.children The content of the page. If not set, it will render a ForgotPasswordForm.
 *
 * @example
 * import { ForgotPasswordPage } from 'ra-supabase-ui-materialui';
 * import { Admin, CustomRoutes } from 'react-admin';
 *
 * const App = () => (
 *    <Admin dataProvider={dataProvider}>
 *      <CustomRoutes>
 *       <Route path={ForgotPasswordPage.path} element={<ForgotPasswordPage />} />
 *     </CustomRoutes>
 *      ...
 *  </Admin>
 * );
 */
export const MySetPasswordPage = (props) => {
    const { children = <MySetPasswordForm /> } = props;

    return <AuthLayout>{children}</AuthLayout>;
};

MySetPasswordPage.path = '/set-password';